export default __webpack_public_path__ + "static/media/soldIcon.a371e5f9.svg";